import React from 'react';
import { useSelector } from 'react-redux';
import { getDraftTravelContractAndSaveInCache } from '../../redux/modules/travelContract';
import ContractConfirmation from './ContractConfirmation';

import TravelCalcHeaderImage from '../../img/travelHeader.png';

const TravelContractConfirmation = () => {
  const { loadingDraftContract, savingContractInCache } = useSelector(
    (state) => state.travelContract,
  );

  return (
    <ContractConfirmation
      headerText="travelContract.title"
      headerImage={TravelCalcHeaderImage}
      type="travel"
      loadingOrSavingInCache={loadingDraftContract || savingContractInCache}
      getDraftContractAndSaveInCache={getDraftTravelContractAndSaveInCache}
    />
  );
};

export default TravelContractConfirmation;
